import { ReactElement } from "react";
import styles from "../styles/MeterMan.module.css";

const meterManUrl: string = "https://i-am-the-meter-man.vercel.app/";

/** Displays the Meter Man website within the portfolio. */
export default function MeterManPage(): ReactElement {
	return (
		<section className={styles.page} aria-label="I Am The Meter Man">
			<iframe
				className={styles.frame}
				src={meterManUrl}
				title="I Am The Meter Man website"
			/>
		</section>
	);
}
